export default function Eyebrow({ children, tone = "blue", className = "" }) {
  const color = tone === "teal" ? "text-teal" : "text-blue";
  return (
    <span className={`eyebrow ${color} ${className}`} data-testid="section-eyebrow">
      {children}
    </span>
  );
}
